
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(11|35|397|434|56|768|958)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
